<template>
  <svg width="24" height="24" fill="currentColor">
    <use xlink:href="/img/sprite.svg#ic_booking-hollow" v-if="type === 'flexible'" />
    <use xlink:href="/img/sprite.svg#ic_booking-solid" v-if="type === 'super_flexible'" />
  </svg>
</template>

<script>
export default {
  name: 'BookingTermIcon',
  props: ['type']
}
</script>
